var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg45Opt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 -0.5 17 17",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    transform: "translate(-0.5,0.522)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.354 15.29H4.022v-3.844l2.71-2.71 3.77 3.768-1.14 1.202Z",
    style: {
      fill: "#000000",
      stroke: "#000000",
      strokeWidth: 0.02125
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg45Opt);
export default __webpack_public_path__ + "static/media/45_opt.954ad71613d6b8cd2c66fa10626e3c5f.svg";
export { ForwardRef as ReactComponent };